import { FormattedMessage } from 'react-intl';
import SubHeadline from '../../../atoms/SubHeadline';
import './style.scss';
import { getAssetUrl, config } from '../../../../utils/config';
import { pushTrackingEvent } from '../../../../utils/tracking';

type ExpressOption = {
  key: string;
  icon: string;
  backgroundColor: string;
};

const expressOptions: ExpressOption[] = [
  {
    key: 'payPal',
    icon: 'payPal',
    backgroundColor: '#ffc439',
  },
  {
    key: 'applePay',
    icon: 'applePay',
    backgroundColor: '#000000',
  },
  {
    key: 'amazonPay',
    icon: 'amazonPay',
    backgroundColor: '#333e47',
  },
];

const ExpressCheckout = () => {
  const enabledExpressOptions = expressOptions.filter(item => config.features.expressCheckout[item.key].enabled);
  const handleClick = (option: ExpressOption) => {
    pushTrackingEvent({
      event: 'express_checkout',
      action: option.key,
      label: null,
    });
    console.log(`Clicked: ${option.icon}`);
  };

  return (
    <>
      {!!enabledExpressOptions.length && (
        <div className="express-checkout">
          <SubHeadline>
            <FormattedMessage id="auth.expressCheckoutHeadline" />
          </SubHeadline>
          <div className="express-checkout__container">
            {enabledExpressOptions.map(option => (
              <div
                className="express-checkout__option"
                style={{ backgroundColor: option.backgroundColor }}
                onClick={() => handleClick(option)}
                key={option.icon}
              >
                <img src={getAssetUrl(`login/${option.icon}.svg`)} alt={option.icon} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ExpressCheckout;
